import $ from 'jquery'
import appActions from '../actions/AppActions'
import '../stores/AppStore';

const templateData = $('body').data()


appActions.changeAmount({ amount: templateData.donationAmount.toString() })
appActions.changeSymbol({ symbol: templateData.donationSymbol })
appActions.changeCode({ code: templateData.donationCode })
appActions.changeNote({ note: templateData.donationNote })

export function localsMessages(templateName) {
	if (!templateName) {
		console.warn('Missing template name');
	}
	try {
		const localsAllMessages = JSON.parse(document.getElementById('localsMessages').innerHTML || {});
		return localsAllMessages[templateName] || localsAllMessages;
	} catch (e) {
		console.warn('Please attach locales to DOM');
		return {}
	}
}

export default templateData;



/** WEBPACK FOOTER **
 ** ./utility/getTemplateData.js
 **/